<template>
    <div class="famousSnacks discount" style="margin: 40px auto 20px; auto">
        <div class="discont_header">
            <div class="h-left">
                <span class="tit">名小吃</span>
                <span class="info" style="margin-left:14px">各地小吃</span>
            </div>
            <div class="h-right" style="width:90px;height:32px;line-height:32px;border-radius:16px;">
                <router-link
                    class="link"
                    to="famoussnacks"
                >更多</router-link>
            </div>
        </div>
        <div style="display: flex;"><!--class="discont_menu"-->
            <div
                class="discont_item marketlistbut"
                style="cursor: pointer;margin-right:46px"
                v-for="(item,index) in discount_list"
                :key="index"
                @click="detalisClick(item.twoCategoryId, item.categoryId)"
            >
                <div class="pic" style="height:auto"><img
                        :src="item.cover"
                        :alt="item.name"
                        width="100%"
                        height="100%"
                    ></div>
                <div class="discont_bottom">
                    <div class="discont_box">
                        <div class="sales_price dis-between"><div><span style="font-size: 12px;">￥</span>{{item.price}}元</div><div style="color:#999999;display:none">已售 {{item.salesSum}}</div></div>
                    </div>
                    <!-- <div v-if="item.goodsSize" class="good-size-p2">{{item.goodsSize}}</div> -->
                    <div class="tit">{{item.name}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import productApi from "../../api/product"

    export default
    {
        name: "famousSnacks",
        data()
        {
            return {
                discount_list: [],
                OneCategoryId: 0
            }
        },
        created() {
            this.discountListFn()
        },
        mounted()
        {

        },
        methods:
        {
            detalisClick(twoCategoryId, categoryId){
                if(this.authMarketAddressFn()) return
				this.$router.push({
					path:'/famoussnacks_list',
					query:{
                        OneCategoryId: this.OneCategoryId,
                        TwoCategoryId: twoCategoryId,
						categoryId:categoryId
					}
				})
			},
            // +----------------------------------------
            authMarketAddressFn() {
                let that = this
                // if ( !localStorage.getItem('token') )
                // {
                //     this.$confirm( '此操作需要登录, 是否前往登录?', '提示',
                //     {
                //         confirmButtonText: '确定',
                //         cancelButtonText: '取消',
                //         type: 'warning'
                //     } ).then( () =>
                //     {
                //         this.$router.push({path: '/login'})
                //     } ).catch( () =>
                //     {
                //         // ...
                //     } )
                //     return 1
                // }
                if (!JSON.parse( localStorage.getItem( 'AddressActObj' )) ) {
                    this.$confirm( '请选择收货地址？', '提示',
                    {
                        confirmButtonText: '前往选择',
	                    showCancelButton: false,
						showClose: false,
						closeOnClickModal: false,
                        // cancelButtonText: '取消',
                        type: 'warning'
                    }).then( () =>
                    {
                        localStorage.setItem( 'isSetOneAddress', 1 )
                        that.$router.push( { path: '/marketlist?num=2' } )
                    }).catch( () =>
                    {
                        // ...
                    })

                    return 1
                }
            },
            // +----------------------------------------
            discountListFn() {
                let cityname = JSON.parse( localStorage.getItem( 'cityname' ) )

                if (cityname == null) {
                    let that = this
                    setTimeout(() => {
                        cityname = JSON.parse( localStorage.getItem( 'cityname' ) )
                        that.reqFn(cityname) 
                    }, 2000);
                    return
                }
                this.reqFn(cityname)
            },
            reqFn(cityname) {
                productApi.MMCProductCategoryTree().then((res) => {
                    this.OneCategoryId = res.data.result[0].id
                    let addId = {}
                    productApi.GetMMCCategoryShopGoodList(addId).then((res) => {
                        let childrenData = res.data.result
                        let data = []
                        for (let j = 0; j < childrenData.length; j++) {
                            data = data.concat(childrenData[j].goodsList)
                        }
                        for (let i = 0; i < data.length; i++) {
                            if (i < 5) this.discount_list.push(data[i])
                        }
                    })
                }).catch((err) => {
                    // ...
                })
            }
        }
    }
</script>
<style scoped>
    .marketlistbut{
        transition-duration: 0.4s;
    }

    .marketlistbut:hover {
		-webkit-box-shadow: #ccc 200px 20px 20px;
		-moz-box-shadow: #ccc 10px 10px 10px;
		box-shadow: #ccc 10px 10px 10px;
		-webkit-transform: translate(0px, -5px);
		-moz-transform: translate(5px, 5px);
		background-color: #FFFFFF;
		cursor: pointer;
	}
    .discont_menu {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .discont_menu .pic {
        width: 180px;
        height: 180px;
    }

    .discont_menu .discont_bottom {
        width: 180px;
    }

    .discont_item {
        background-color: #f5f5f5;
        width: 200px;
        display: block;
        padding:10px
    }

    .discont_item .discont_box {
        /* display: flex;
        flex-direction: row;
        justify-content: space-between; */
        margin: 17px 0 24px;
    }

    .discont_item .discont_box .sales_price {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FF4949;
    }

    .discont_item .discont_box .sales_count {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #999999;
    }

    .discont_item .discont_bottom .tit {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #434343;
    }

    .discount {
        width: 1200px;
        margin: 40px auto 50px;
        background: #ffffff;
        padding: 0 20px 20px 20px;
    }

    .discont_header {
        height: 65px;
        line-height: 65px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: relative;
    }


    .discont_header .h-left .tit {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
    }

    .discont_header .h-left .info {
        display: inline-block;
        width: 72px;
        height: 20px;
        line-height: 20px;
        background: #11D165;
        border-radius: 5px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        text-align: center;
        color: #FFFFFF;
    }

    .h-right {
        width: 50px;
        height: 26px;
        border: 1px solid #434343;
        border-radius: 13px;
        line-height: 26px;
        text-align: center;
    }

    .h-right .link {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #434343;

    }
    @import '../../assets/style/base.css'
</style>